<template>
<loader v-bind="{ loading }">
  <div class="columns">
    <div class="column">
      <h3 class="is-size-3">
        {{ software.name }} 
        <span v-if="software.latest_version" class="has-text-grey has-text-weight-light">
          {{ software.latest_version.code }}
        </span>
      </h3>
      <div class="buttons">
        <action-button :working="updatingVersions" @click="runVersionUpdate">Update Software Versions</action-button>
        <action-button :working="updatingVulnerabilities" @click="runVulnerabilityUpdate">Update Vulnerabilities</action-button>
      </div>
    </div>
  </div>
</loader>  
</template>
<script>
import { mapGetters } from 'vuex'

export default {

  data: () => ({
    updatingVersions: false,
    updatingVulnerabilities: false,
    loading: false
  }),

  methods: {
    runVersionUpdate() {
      this.updatingVersions = true
       this.$store.dispatch('software/runVersionUpdate', this.software.id).then(() => {
         this.updatingVersions = false
         this.updatingVulnerabilities = false
         this.$toast.success('update process started')
         this.$toast.info('check back later for the results...')
       })
    },
    runVulnerabilityUpdate() {
      this.updatingVulnerabilities = true
       this.$store.dispatch('software/runVulnerabilityUpdate', this.software.id).then(() => {
         this.updatingCves = false
         this.updatingVulnerabilities = false
         this.$toast.success('update process started')
         this.$toast.info('check back later for the results...')
       })
    },
  },

  computed: {
    ...mapGetters('software', [
      'software'
    ])
  }
}
</script>